import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../shared/shared.module';
import { SkillsComponent } from './skills/skills.component';
import { BannerComponent } from './banner/banner.component';
import { AboutComponent } from './about/about.component';
import { ServiceComponent } from './service/service.component';
import { TeamComponent } from './team/team.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { FaqsComponent } from './faqs/faqs.component';
import { PortfolioComponent } from './portfolio/portfolio.component'
import { TranslocoRootModule } from 'src/app/transloco-root.module';


@NgModule({
  declarations: [HomeComponent, SkillsComponent, BannerComponent, AboutComponent, ServiceComponent, TeamComponent, AboutUsComponent, FaqsComponent, PortfolioComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    NgbModule,
    SlickCarouselModule,
    NgCircleProgressModule.forRoot(),
    TranslocoRootModule
  ]
})
export class HomeModule { }
